import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NOB from '../../../../constants/language-strings';
import { POWER, SNR, UPSTREAM } from 'modules/HealthCheck/constants';
import { colorPicker } from 'modules/HealthCheck/helpers';
import styled from 'styled-components';
import spacing from 'theme/spacing';
import { purpurColorGray50 } from '@purpurds/tokens/color/variables';
const StreamChannelContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const StreamChannelHeadings = styled.div `
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-end;
  font-size: 20px;
  padding: ${spacing.spacing4} 0;
  margin-top: ${spacing.spacing8};
  line-height: normal;
  letter-spacing: normal;
  text-align: center;

  div:first-child {
    display: flex;
    justify-content: center;
    margin-left: ${spacing.spacing16};
    width: 25px;
  }

  div:not(:first-child) {
    display: flex;
    justify-content: center;
    flex: 1;
  }
`;
const StreamChannelItems = styled.div `
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: ${spacing.spacing4} 0;
  letter-spacing: normal;

  div:first-child {
    display: flex;
    justify-content: center;
    margin-left: ${spacing.spacing16};
    width: 25px;
  }

  div:not(:first-child) {
    display: flex;
    justify-content: flex-end;
    flex: 1;
    margin-right: 10%;
  }
  
  :nth-child(odd) {
    background-color: ${purpurColorGray50};
  }

  @media (min-width: 400px) {
    div:not(:first-child) {
      margin-right: 13.5%;
    }
  }
`;
const StyledItemColor = styled.div `
  color: ${({ $statusColor }) => $statusColor};
`;
export const StreamChannel = ({ channels, type = UPSTREAM, scoreVariables, }) => {
    const renderChannels = channels.map(response => response.Snr !== -1000 && response.Frequency !== 0 ? (_jsxs(StreamChannelItems, { children: [_jsx("div", { children: response.Channel }), _jsx("div", { children: response.Frequency }), _jsx(StyledItemColor, { "$statusColor": colorPicker(scoreVariables, POWER, type, response), children: response.Power }), _jsx(StyledItemColor, { "$statusColor": colorPicker(scoreVariables, SNR, type, response), children: response.Snr })] }, `${type}-${response.Channel}`)) : (_jsx("div", {}, `empty-${type}`)));
    return (_jsxs(StreamChannelContainer, { children: [_jsxs(StreamChannelHeadings, { children: [_jsx("div", { children: NOB.DOWNSTREAM_UPSTREAM.CH }), _jsxs("div", { children: [NOB.DOWNSTREAM_UPSTREAM.FREQ, _jsx("br", {}), NOB.DOWNSTREAM_UPSTREAM.MHZ] }), _jsxs("div", { children: [NOB.DOWNSTREAM_UPSTREAM.SIGNAL_POWER, _jsx("br", {}), NOB.DOWNSTREAM_UPSTREAM.DBMV] }), _jsxs("div", { children: [NOB.DOWNSTREAM_UPSTREAM.SNR, _jsx("br", {}), NOB.DOWNSTREAM_UPSTREAM.DB] })] }), renderChannels] }));
};
